import styled from '@emotion/styled';
import { Dialog, DialogContent } from '@mui/material';
import { StyledDiv } from 'theme/commonStyled';

export const StyledDialog = styled(Dialog)`
  z-index: ${({ theme }): number => theme.zIndices[20]};
`;

export const StyledDialogContent = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledTypography = styled(StyledDiv)`
  font-family: ${({ theme }): string => theme.fonts.body};
  line-height: 1.5;
  margin: 0 auto;
  font-size: ${({ theme }): string => theme.fontSizes[10]};
`;
